const videoControls = {
    handleVideoPlay: (e) => {
        const button = e.currentTarget;
        const video = button.previousElementSibling;
        video.play();
        button.classList.add("rs-play--hidden");
    },
    handleVideoEnd: (e) => {
        const video = e.currentTarget;
        const button = video.nextElementSibling;
        button.classList.remove("rs-play--hidden");
    },
    handleEmbedPlay: (e) => {
        const button = e.currentTarget;
        const iframe = button.previousElementSibling;
        const src = iframe.src.replace(/autoplay=\d/, "autoplay=1");
        iframe.src = src;
        button.classList.add("rs-play--hidden");
    },
    videoInit: (el) => {
        const videoButtons = document.querySelectorAll(el); //.rs-video .rs-play

        if (videoButtons) {
            videoButtons.forEach(button => {
                const video = button.previousElementSibling;
                button.addEventListener("click", videoControls.handleVideoPlay);

                // If not a looping video and controls aren't enabled, make sure to
                // redisplay play button on video end.
                if (!video.loop && !video.controls) {
                    video.addEventListener("ended", videoControls.handleVideoEnd);
                }
            });
        }
    },
    embedInit: (el) => {
        const embedButtons = document.querySelectorAll(el);

        if (embedButtons) {
            embedButtons.forEach(button => {
                const video = button.previousElementSibling;
                button.addEventListener("click", videoControls.handleEmbedPlay);
            });
        }
    },
    init: (videoEl, embedEl) => {
        videoControls.videoInit(videoEl);
        videoControls.embedInit(embedEl);
    },
}

export default videoControls;
